import React from 'react';
import i18n from 'i18next';
import { AppRouteGroup } from 'app/store/components/NavigationUtils';

import { lazyRetry } from 'app/main/components';

import DocumentDetails from './details/DocumentsDetails';
import DocumentsFolderView from './view/DocumentsFolderView';

import buttons from './DocumentsButtons';

import en from './i18n/en';
import it from './i18n/it';
import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import DocumentsUsersListItem from './details/tabs/DocumentsUsersListItem';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18n.addResourceBundle('en', 'core', en);
i18n.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('sys_documents_folders'),
	routes: [
		{
			path: 'sys/documents/folders/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'sys_documents_folders'),
			element: (
				<DetailsPage
					key="documents/folders/add"
					module="sys_documents_folders"
					headerOptions={{ showAvatar: true }}
					tabs={DocumentDetails}
					buttons={buttons.details}
					isAdd
				/>
			)
		},
		{
			path: 'sys/documents/folders/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'sys_documents_folders'),
			element: (
				<DetailsPage
					key="documents/folders/details"
					module="sys_documents_folders"
					headerOptions={{ showAvatar: true }}
					tabs={DocumentDetails}
					buttons={buttons.details}
					// events={events}
				/>
			)
		},
		{
			path: 'sys/documents/folders/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'sys_documents_folders'),
			element: (
				<ViewPage
					key="documents/folders/view"
					module="sys_documents_folders"
					content={{ type: 'tabs', tabs: DocumentsFolderView }}
					buttons={buttons.view}
					showExportButton={false}
				/>
			)
		}
	]
};

export default routes;
